type StartParam = 'backend_en' | 'backend_ru'

export const getBackendUrl = (): string => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const startParam = urlParams.get('startapp') as StartParam;
        const enUrl = import.meta.env.VITE_API_BASE_URL_EN;
        const ruUrl = import.meta.env.VITE_API_BASE_URL_RU;

        switch (startParam) {
            case 'backend_en':
                if(enUrl) {
                    console.log('bot_EN');
                    return import.meta.env.VITE_API_BASE_URL_EN;
                } else {
                    console.error('VITE_API_BASE_URL_EN is not defined');
                    return 'https://ERROR/';
                }
            case 'backend_ru':
                if (ruUrl) {
                    console.log('bot_RU');
                    return import.meta.env.VITE_API_BASE_URL_RU
                } else {
                    console.error('VITE_API_BASE_URL_RU is not defined');
                    return  'https://ERROR/';
                }



            default:
                console.error('UNDEFINED, startParam:', startParam);
                return 'https://ERROR/';
        }
    } catch (error) {
        console.error('Failed to retrieve params:', error);
        return 'https://ERROR/';
    }
};
